/**
 * Created by lxhfight on 2017/11/15.
 * Email: lxhfight1@gmail.com
 * Description:
 */

export const isArray = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Array]'
}

export const getDate = (str) => {
  let date = ''
  if (str) {
    date = new Date(str)
  } else {
    date = new Date()
  }
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${date.getFullYear()}-${month >= 10 ? month : ('0' + month)}-${day >= 10 ? day : ('0' + day)}`
}

export const getDateTime = (str) => {
  const date = new Date(str)
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minite = date.getMinutes()
  const second = date.getSeconds()
  return `${date.getFullYear()}-${month >= 10 ? month : ('0' + month)}-${day >= 10 ? day : ('0' + day)}` +
    ` ${hour >= 10 ? hour : ('0' + hour)}:${minite >= 10 ? minite : ('0' + minite)}:${second >= 10 ? second : ('0' + second)}`
}

export const getDateOnly = (str) => {
  const date = new Date(str)
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${month >= 10 ? month : ('0' + month)}月${day >= 10 ? day : ('0' + day)}日`
}
export const smartImagePath = (path, isSmall = true, original = false) => {
  let imagePath = path
  if (!imagePath) {
    return null
  }
  let suffix = imagePath.substring(imagePath.lastIndexOf('.'))
  let type = isSmall ? '-small' : '-big'
  type = original ? '' : type
  if ((!imagePath.includes('s3-ap-southeast-1.amazonaws.com') &&
      !imagePath.includes('api.give543.com')) ||
    imagePath.includes('zrockgive') ||
    imagePath.includes('request') ||
    imagePath.includes('/test/') ||
    (imagePath.includes('/avatar/') && type === '-big') ||
    (imagePath.includes('/chat/') && type === '-big') ||
    suffix === '.gif') {
    return imagePath.replace('s3-ap-southeast-1.amazonaws.com/next.give543', 'd2hrw3sjxwwsb1.cloudfront.net')
  }
  const index = imagePath.lastIndexOf('.')
  imagePath = `${imagePath.substring(0, index)}${type}${imagePath.substring(index)}`
  return imagePath.replace('s3-ap-southeast-1.amazonaws.com/next.give543', 'd2hrw3sjxwwsb1.cloudfront.net')
}



// WEBPACK FOOTER //
// ./src/utils/object.js